import Space from "./Space";
import "venuescanner-scss/stylesheets/widgets/tiles/space_tile/_space_tile.scss";

export default Space;
